module.exports = __webpack_public_path__ + "img/policy-01.68fa217f.webp";